(function () {
  'use strict';

  if (window.CanvasGuyModern) return;

  const STORAGE = {
    saved: 'cg_saved_products_v2',
    compare: 'cg_compare_products_v2',
    recent: 'cg_recently_viewed'
  };
  const state = {
    aborter: new AbortController(),
    revealObserver: null,
    stickyObserver: null,
    headerResizeObserver: null,
    lastFocus: null,
    initialized: new WeakSet()
  };

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  /* Shared by both the shop filter (initCollectionTools) and the projects
     filter (initProjectFilters). Lived inside initCollectionTools until the
     projects filter needed the same word-boundary matching; hoisted rather
     than duplicated so the two filters can't drift apart. */
  const normalize = value => String(value || '')
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[×x]/g, 'x')
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\bmatt\b/g, 'matte')
    .trim();

  function readStore(key) {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (_) {
      return [];
    }
  }

  function writeStore(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (_) {
      toast('Your browser could not save this preference.');
      return false;
    }
  }

  function escapeHTML(value) {
    const div = document.createElement('div');
    div.textContent = String(value || '');
    return div.innerHTML;
  }

  function toast(message) {
    const region = $('[data-cg-toasts]');
    if (!region) return;
    const item = document.createElement('div');
    item.className = 'cg-toast';
    item.textContent = message;
    region.appendChild(item);
    window.setTimeout(() => item.remove(), 3600);
  }

  function currentProduct() {
    const el = $('[data-cg-product]');
    if (!el) return null;
    return {
      handle: el.dataset.productHandle || '',
      title: el.dataset.productTitle || '',
      url: el.dataset.productUrl || location.pathname,
      image: el.dataset.productImage || '',
      price: el.dataset.productPrice || '',
      type: el.dataset.productType || '',
      available: el.dataset.productAvailable === 'true'
    };
  }

  function saveProduct(product, collection, limit) {
    if (!product || !product.url) return false;
    const items = readStore(collection).filter(item => item.url !== product.url);
    items.unshift(product);
    if (writeStore(collection, items.slice(0, limit))) {
      syncQuickAccess();
      return true;
    }
    return false;
  }

  function removeProduct(url, collection) {
    writeStore(collection, readStore(collection).filter(item => item.url !== url));
    syncQuickAccess();
  }

  function trackRecent() {
    const product = currentProduct();
    if (product) saveProduct(product, STORAGE.recent, 12);
  }

  function quickAccess() {
    if ($('[data-cg-quick-access]')) return;
    const nav = document.createElement('div');
    nav.className = 'cg-quick-access';
    nav.dataset.cgQuickAccess = '';
    nav.innerHTML = `
      <button type="button" data-cg-open="saved" aria-label="Open saved pieces">Saved <span data-cg-saved-count>0</span></button>
      <button type="button" data-cg-open="compare" aria-label="Open product comparison">Compare <span data-cg-compare-count>0</span></button>`;
    document.body.appendChild(nav);
    syncQuickAccess();
  }

  function syncQuickAccess() {
    const savedCount = readStore(STORAGE.saved).length;
    const compareCount = readStore(STORAGE.compare).length;
    $$('[data-cg-saved-count]').forEach(el => {
      el.textContent = String(savedCount);
      const button = el.closest('button');
      if (button) button.hidden = savedCount === 0;
    });
    $$('[data-cg-compare-count]').forEach(el => {
      el.textContent = String(compareCount);
      const button = el.closest('button');
      if (button) button.hidden = compareCount === 0;
    });
    const nav = $('[data-cg-quick-access]');
    if (nav) nav.hidden = savedCount === 0 && compareCount === 0;
  }

  function renderSaved() {
    const root = $('[data-cg-saved-list]');
    if (!root) return;
    const items = readStore(STORAGE.saved);
    if (!items.length) {
      root.innerHTML = '<div class="cg-modern-empty">You have not saved any pieces yet. Use “Save piece” on a product page to build a shortlist.</div>';
      return;
    }
    root.innerHTML = `<div class="cg-saved-grid">${items.map(item => `
      <article class="cg-saved-item">
        ${item.image ? `<img src="${escapeHTML(item.image)}" alt="" loading="lazy" width="148" height="148">` : '<span></span>'}
        <div><a class="cg-saved-item__title" href="${escapeHTML(item.url)}">${escapeHTML(item.title)}</a><div class="cg-saved-item__meta">${escapeHTML(item.type)}${item.price ? ` · ${escapeHTML(item.price)}` : ''}</div></div>
        <button class="cg-saved-item__remove" type="button" data-cg-remove-saved="${escapeHTML(item.url)}" aria-label="Remove ${escapeHTML(item.title)}">×</button>
      </article>`).join('')}</div>`;
  }

  function renderCompare() {
    const root = $('[data-cg-compare-list]');
    if (!root) return;
    const items = readStore(STORAGE.compare);
    if (!items.length) {
      root.innerHTML = '<div class="cg-modern-empty">Add up to three pieces from their product pages to compare them here.</div>';
      return;
    }
    root.innerHTML = `<div class="cg-compare-scroll"><table class="cg-compare-table"><tbody>
      <tr><th>Piece</th>${items.map(item => `<td><a href="${escapeHTML(item.url)}"><strong>${escapeHTML(item.title)}</strong></a></td>`).join('')}</tr>
      <tr><th>Image</th>${items.map(item => `<td>${item.image ? `<img src="${escapeHTML(item.image)}" alt="" loading="lazy" width="150" height="110" style="width:150px;height:110px;object-fit:cover;border-radius:10px">` : '—'}</td>`).join('')}</tr>
      <tr><th>Type</th>${items.map(item => `<td>${escapeHTML(item.type || '—')}</td>`).join('')}</tr>
      <tr><th>Price</th>${items.map(item => `<td>${escapeHTML(item.price || 'View product')}</td>`).join('')}</tr>
      <tr><th>Availability</th>${items.map(item => `<td>${item.available ? 'Available to order' : 'Check availability'}</td>`).join('')}</tr>
      <tr><th></th>${items.map(item => `<td><button type="button" class="cg-modern-button cg-modern-button--ghost" data-cg-remove-compare="${escapeHTML(item.url)}">Remove</button></td>`).join('')}</tr>
    </tbody></table></div>`;
  }

  function openModal(name, opener) {
    const overlay = $(`[data-cg-modal="${name}"]`);
    if (!overlay) return;
    state.lastFocus = opener || document.activeElement;
    if (name === 'saved') renderSaved();
    if (name === 'compare') renderCompare();
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const modal = $('.cg-modern-modal', overlay);
    window.requestAnimationFrame(() => modal && modal.focus());
  }

  function closeModal(overlay) {
    if (!overlay) return;
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (state.lastFocus && typeof state.lastFocus.focus === 'function') state.lastFocus.focus();
  }

  function initReveal(root) {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      $$('[data-cg-reveal]', root).forEach(el => el.classList.add('is-visible'));
      return;
    }
    document.documentElement.classList.add('cg-reveal-ready');
    if (!state.revealObserver) {
      state.revealObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          state.revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    $$('[data-cg-reveal]', root).forEach(el => state.revealObserver.observe(el));
  }

  function enhanceSections(root) {
    const selectors = [
      '.cg-hero__max', '.cg-3col__inner > *', '.cg-stats__inner > *',
      '.cg-why__inner > *', '.cg-projects__inner > *', '.cg-sister__inner > *',
      '.cg-shopgrid__card', '.cg-mirgrid__card', '.cg-prodrel__card'
    ];
    selectors.forEach(selector => $$(selector, root).forEach(el => el.setAttribute('data-cg-reveal', '')));
    initReveal(root);
  }

  function initDelivery(root) {
    $$('[data-cg-delivery]', root).forEach(select => {
      if (state.initialized.has(select)) return;
      state.initialized.add(select);
      const result = $('[data-cg-delivery-result]', select.closest('.cg-product-tool'));
      const estimates = {
        nairobi: ['1–3 working days', 'Same-week delivery for in-stock pieces; made-to-order timing is added separately.'],
        central: ['2–5 working days', 'Protected road delivery. Final fee is confirmed from the exact town and piece size.'],
        major: ['3–7 working days', 'Specialist courier delivery. Oversized mirrors may require a dedicated quote.'],
        national: ['4–9 working days', 'We confirm the safest carrier and exact delivery fee before dispatch.'],
        regional: ['7–18 working days', 'East Africa export is quoted individually, including packaging and border requirements.']
      };
      select.addEventListener('change', () => {
        const estimate = estimates[select.value];
        result.innerHTML = estimate ? `<strong>${estimate[0]}</strong><br>${estimate[1]}` : 'Select an area for an estimate.';
      }, { signal: state.aborter.signal });
    });
  }

  function initRoomPreview(root) {
    const stage = $('[data-cg-room-stage]', root);
    const art = $('[data-cg-room-art]', root);
    const upload = $('[data-cg-room-upload]', root);
    const size = $('[data-cg-room-size]', root);
    if (!stage || !art || state.initialized.has(stage)) return;
    state.initialized.add(stage);

    upload?.addEventListener('change', () => {
      const file = upload.files && upload.files[0];
      if (!file || !file.type.startsWith('image/') || file.size > 12 * 1024 * 1024) {
        toast('Choose a JPG, PNG, or WebP image smaller than 12 MB.');
        upload.value = '';
        return;
      }
      const reader = new FileReader();
      reader.onload = () => { stage.style.backgroundImage = `url("${reader.result}")`; };
      reader.readAsDataURL(file);
    }, { signal: state.aborter.signal });

    size?.addEventListener('input', () => { art.style.width = `${size.value}%`; }, { signal: state.aborter.signal });

    let dragging = false;
    function move(event) {
      if (!dragging) return;
      const rect = stage.getBoundingClientRect();
      const x = Math.max(0, Math.min(rect.width, event.clientX - rect.left));
      const y = Math.max(0, Math.min(rect.height, event.clientY - rect.top));
      art.style.left = `${(x / rect.width) * 100}%`;
      art.style.top = `${(y / rect.height) * 100}%`;
    }
    art.addEventListener('pointerdown', event => {
      dragging = true;
      art.setPointerCapture(event.pointerId);
      move(event);
    }, { signal: state.aborter.signal });
    art.addEventListener('pointermove', move, { signal: state.aborter.signal });
    art.addEventListener('pointerup', () => { dragging = false; }, { signal: state.aborter.signal });
    art.addEventListener('pointercancel', () => { dragging = false; }, { signal: state.aborter.signal });
  }

  function initStickyPurchase(root) {
    const bar = $('[data-cg-sticky-atc]', root);
    const productForm = $('form[action*="/cart/add"]');
    if (!bar || !productForm || state.initialized.has(bar)) return;
    state.initialized.add(bar);
    const submit = $('[type="submit"][name="add"], [type="submit"]', productForm);
    if (!submit) return;

    if ('IntersectionObserver' in window) {
      state.stickyObserver?.disconnect();
      state.stickyObserver = new IntersectionObserver(entries => {
        const visible = !entries[0].isIntersecting && window.scrollY > 380;
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', String(!visible));
      }, { threshold: 0 });
      state.stickyObserver.observe(submit);
    }

    $('[data-cg-sticky-submit]', bar)?.addEventListener('click', () => submit.click(), { signal: state.aborter.signal });
    productForm.addEventListener('change', () => updateStickyVariant(productForm, bar), { signal: state.aborter.signal });
    updateStickyVariant(productForm, bar);
  }

  function updateStickyVariant(form, bar) {
    const id = $('[name="id"]', form)?.value;
    const data = $('[data-cg-product-variants]');
    const output = $('[data-cg-sticky-variant]', bar);
    if (!id || !data || !output) return;
    try {
      const variant = JSON.parse(data.textContent).find(item => String(item.id) === String(id));
      if (!variant) return;
      const money = window.Shopify?.formatMoney && window.theme?.moneyFormat
        ? window.Shopify.formatMoney(variant.price, window.theme.moneyFormat)
        : currentProduct()?.price || '';
      output.textContent = `${variant.title} · ${money}`;
      const button = $('[data-cg-sticky-submit]', bar);
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'Add to cart' : 'Unavailable';
      updateWhatsApp(form, variant);
    } catch (_) {}
  }

  function updateWhatsApp(form, variant) {
    const link = $('[data-cg-whatsapp]');
    const product = currentProduct();
    if (!link || !product) return;
    const selected = $$('.active[data-value]', form.closest('section') || document).map(el => el.dataset.value).filter(Boolean);
    const quantity = $('[name="quantity"]', form)?.value || '1';
    const details = variant?.title && variant.title !== 'Default Title' ? variant.title : selected.join(', ');
    const message = `Hi Canvas Guy, I would like help with ${product.title}${details ? ` (${details})` : ''}, quantity ${quantity}. ${location.origin}${product.url}`;
    const number = (link.href.match(/wa\.me\/(\d+)/) || [])[1] || '254713196650';
    link.href = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
  }

  function initCollectionTools(root) {
    const filter = $('.cg-shopfilter__inner', root) || $('.cg-shopfilter__inner');
    const grid = $('.cg-shopgrid__grid, .cg-mirgrid__grid', root) || $('.cg-shopgrid__grid, .cg-mirgrid__grid');
    if (!filter || !grid || state.initialized.has(filter)) return;
    state.initialized.add(filter);
    const cards = $$('.cg-shopgrid__card, .cg-mirgrid__card, [data-cg-filter-card]', grid);
    if (!cards.length) return;
    cards.forEach(card => { card.dataset.cgOriginalHidden = card.dataset.hidden || 'false'; });

    const sort = document.createElement('select');
    sort.className = 'cg-shopfilter__btn';
    sort.setAttribute('aria-label', 'Sort products');
    sort.innerHTML = '<option value="featured">Sort: Featured</option><option value="title">Name: A–Z</option><option value="price-asc">Price: Low–high</option><option value="price-desc">Price: High–low</option>';
    const count = $('[class*="__count"]', filter);
    filter.insertBefore(sort, count || null);

    const filters = $$('[data-cg-product-filter]', filter);
    const reset = $('[data-cg-filter-reset]', filter);
    const empty = $('[data-cg-filter-empty]', grid);
    const loadMore = $('.cg-shopgrid__loadmore-btn', grid.closest('section'));

    function apply() {
      const selected = filters.map(el => normalize(el.value)).filter(Boolean);
      const showingFilteredSet = selected.length > 0 || sort.value !== 'featured';
      let visible = 0;
      cards.forEach(card => {
        /* Matches only against data-filter-values (title/type/vendor/tags/
           option values the section deliberately exposes for filtering),
           never the card's full visible textContent or title attributes —
           that used to make a filter for "Black" match any card whose
           price, description or any other visible string happened to
           contain "black" anywhere. Padding with spaces and requiring the
           padded filter value as a substring gives word-boundary matching
           without needing full tokenization on the Liquid side. */
        const searchable = ' ' + normalize(card.dataset.filterValues || '') + ' ';
        const match = selected.every(value => searchable.includes(` ${value} `));
        if (showingFilteredSet) {
          card.removeAttribute('data-hidden');
          card.hidden = !match;
          if (match) visible += 1;
        } else {
          card.hidden = false;
          if (card.dataset.cgOriginalHidden === 'true') card.setAttribute('data-hidden', 'true');
          else card.removeAttribute('data-hidden');
          visible += 1;
        }
      });
      const sorted = cards.slice().sort((a, b) => {
        if (sort.value === 'title') return (a.dataset.productTitle || a.textContent).localeCompare(b.dataset.productTitle || b.textContent);
        if (sort.value.includes('price')) {
          const result = Number(a.dataset.productPrice || 0) - Number(b.dataset.productPrice || 0);
          return sort.value === 'price-desc' ? -result : result;
        }
        return Number(a.dataset.index || 0) - Number(b.dataset.index || 0);
      });
      sorted.forEach(card => grid.appendChild(card));
      /* Fix: appendChild moves each product card to the end of the grid
         one at a time, which silently pushes the untouched custom-order
         card to the front. Re-pin it as the last child after sorting. */
      const customCard = grid.querySelector('[id$="-custom-card"]');
      if (customCard) grid.appendChild(customCard);
      if (count) count.textContent = `${visible} ${visible === 1 ? 'piece' : 'pieces'}`;
      if (reset) reset.hidden = selected.length === 0;
      if (empty) empty.hidden = visible !== 0;
      if (loadMore) loadMore.hidden = showingFilteredSet || Number(loadMore.dataset.visible) >= Number(loadMore.dataset.total);
    }
    [...filters, sort].forEach(select => select.addEventListener('change', apply, { signal: state.aborter.signal }));
    reset?.addEventListener('click', () => {
      filters.forEach(select => { select.value = ''; });
      sort.value = 'featured';
      apply();
      filters[0]?.focus();
    }, { signal: state.aborter.signal });
    apply();
  }

  function initProjectFilters(root) {
    const filter = $('.cg-projfilter__inner', root) || $('.cg-projfilter__inner');
    const grid = $('.cg-projgrid__inner', root) || $('.cg-projgrid__inner');
    if (!filter || !grid || state.initialized.has(filter)) return;
    state.initialized.add(filter);
    const tabs = $$('.cg-projfilter__tab', filter);
    const cards = $$('.cg-projgrid__featured, .cg-projgrid__card', grid);
    tabs.forEach(tab => {
      tab.setAttribute('role', 'button');
      tab.setAttribute('aria-pressed', String(tab.classList.contains('cg-projfilter__tab--active')));
      tab.addEventListener('click', event => {
        /* Normalized with the same function as the card values below, so a
           merchant-entered label with punctuation ("Hotels & Resorts")
           still matches a card tagged "hotels resorts". */
        const label = normalize(tab.textContent);
        const href = tab.getAttribute('href');
        if (!href || href === '#') event.preventDefault();
        else return;
        tabs.forEach(item => {
          const active = item === tab;
          item.classList.toggle('cg-projfilter__tab--active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        cards.forEach(card => {
          /* Same fix as the shop filter's apply() above, which this was
             missed out of: match only data-filter-values, space-padded for
             word-boundary matching. Including card.textContent meant a tab
             like "Retail" also matched any project whose visible copy
             happened to contain the word anywhere. */
          const searchable = ' ' + normalize(card.dataset.filterValues || '') + ' ';
          card.hidden = !(label === 'all' || label === 'all projects' || searchable.includes(` ${label} `));
        });
      }, { signal: state.aborter.signal });
    });
  }

  /* Measures the rendered header group height (announcement bar + header,
     whichever is currently showing) and exposes it as --cg-header-h. The
     shop and projects filter bars are sticky just below the header instead
     of at top:0, so they don't disappear underneath it once you scroll —
     header height varies by breakpoint and by whether the announcement bar
     is enabled, so this has to be measured, not hardcoded. */
  function updateStickyHeaderOffset() {
    const header = $('.shopify-section-group-header-group');
    if (!header) return;
    const height = Math.ceil(header.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--cg-header-h', height + 'px');
  }

  function initStickyHeaderOffset() {
    updateStickyHeaderOffset();
    if (state.headerResizeObserver) return;
    const header = $('.shopify-section-group-header-group');
    if (header && 'ResizeObserver' in window) {
      state.headerResizeObserver = new ResizeObserver(() => updateStickyHeaderOffset());
      state.headerResizeObserver.observe(header);
    }
    window.addEventListener('resize', updateStickyHeaderOffset, { signal: state.aborter.signal });
    window.addEventListener('orientationchange', updateStickyHeaderOffset, { signal: state.aborter.signal });
  }

  function initForms(root) {
    $$('form', root).forEach(form => {
      if (state.initialized.has(form)) return;
      state.initialized.add(form);
      form.addEventListener('submit', () => {
        const submit = $('[type="submit"]', form);
        if (!submit || submit.disabled) return;
        submit.dataset.originalText = submit.textContent;
        submit.textContent = 'Sending…';
        submit.disabled = true;
        window.setTimeout(() => {
          if (!document.contains(submit)) return;
          submit.disabled = false;
          submit.textContent = submit.dataset.originalText || 'Submit';
        }, 8000);
      }, { signal: state.aborter.signal });
    });
  }

  function init(root = document) {
    quickAccess();
    enhanceSections(root);
    initStickyHeaderOffset();
    initDelivery(root);
    initRoomPreview(root);
    initStickyPurchase(root);
    initCollectionTools(root);
    initProjectFilters(root);
    initForms(root);
    trackRecent();
  }

  document.addEventListener('click', event => {
    if (event.target.closest('[data-option-index], .cg-prodmain__qty-btn, .cg-mirprod__qty-btn')) {
      window.setTimeout(() => {
        const form = $('form[action*="/cart/add"]');
        const bar = $('[data-cg-sticky-atc]');
        if (form && bar) updateStickyVariant(form, bar);
      }, 0);
    }
    const open = event.target.closest('[data-cg-open]');
    if (open) {
      event.preventDefault();
      openModal(open.dataset.cgOpen, open);
      return;
    }
    const close = event.target.closest('[data-cg-close]');
    if (close) {
      closeModal(close.closest('[data-cg-modal]'));
      return;
    }
    const overlay = event.target.matches('[data-cg-modal]') ? event.target : null;
    if (overlay) closeModal(overlay);

    const save = event.target.closest('[data-cg-save-current]');
    if (save) {
      const product = currentProduct();
      if (saveProduct(product, STORAGE.saved, 30)) {
        save.setAttribute('aria-pressed', 'true');
        save.textContent = 'Saved';
        toast('Saved to your shortlist.');
      }
    }
    const compare = event.target.closest('[data-cg-compare-current]');
    if (compare) {
      const product = currentProduct();
      const items = readStore(STORAGE.compare);
      if (!items.some(item => item.url === product?.url) && items.length >= 3) {
        toast('You can compare up to three pieces.');
      } else if (saveProduct(product, STORAGE.compare, 3)) {
        compare.setAttribute('aria-pressed', 'true');
        compare.textContent = 'Added to compare';
        toast('Added to comparison.');
      }
    }
    const removeSaved = event.target.closest('[data-cg-remove-saved]');
    if (removeSaved) { removeProduct(removeSaved.dataset.cgRemoveSaved, STORAGE.saved); renderSaved(); }
    const removeCompare = event.target.closest('[data-cg-remove-compare]');
    if (removeCompare) { removeProduct(removeCompare.dataset.cgRemoveCompare, STORAGE.compare); renderCompare(); }
  }, { signal: state.aborter.signal });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = $('[data-cg-modal][aria-hidden="false"]');
    if (open) closeModal(open);
  }, { signal: state.aborter.signal });

  document.addEventListener('shopify:section:load', event => init(event.target), { signal: state.aborter.signal });
  window.addEventListener('pagehide', () => {
    state.revealObserver?.disconnect();
    state.stickyObserver?.disconnect();
    state.headerResizeObserver?.disconnect();
    state.aborter.abort();
  }, { once: true });

  window.CanvasGuyModern = { init, openModal };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
